import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import ProductPage from './Components/ProductPage';
import Footer from './Components/Footer';
import AboutUs from './Components/AboutUs';
import HomePage from './Components/HomePage';
import SplashScreen from './Components/SplashScreen';
import ContactForm from './Components/ContactForm'; // Import ContactForm
import Export from './Components/Export';
import SSScrew from './Components/SSScrew';
import ThreeSlider from './Components/ImageSliderThreeJS';

const pageVariants = {
  initial: {
    opacity: 0,
    y: '100vh'
  },
  in: {
    opacity: 1,
    y: 0
  },
  out: {
    opacity: 0,
    y: '-100vh'
  }
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.5
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <AnimatePresence mode="wait">
          {loading ? (
            <SplashScreen />
          ) : (
            <Routes>
              <Route path="/" element={
                <motion.div
                  key="home"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  <HomePage />
                  
                  <Footer />
                </motion.div>
              } />
              <Route path="/about" element={
                <motion.div
                  key="about"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                
                  <AboutUs />
                  <Footer />
                </motion.div>
              } />
              <Route path="/products" element={
                <motion.div
                  key="products"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  
                  <ProductPage />
                  <Footer />
                </motion.div>
              } />
              <Route path="/threeslide" element={
                <motion.div
                  key="products"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  
                  <ThreeSlider />
                  
                </motion.div>
              } />
              <Route path="/contact" element={
                <motion.div
                  key="contact"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  
                  <ContactForm /> {/* Add the ContactForm here */}
                  <Footer />
                </motion.div>
              } />
              <Route path="/export" element={
                <motion.div
                  key="products"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  
                  <Export />
                 
                </motion.div>
              } />
              <Route path="/ss-screw" element={
                <motion.div
                  key="products"
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  className="flex flex-col min-h-screen"
                >
                  
                  <SSScrew />
                 
                </motion.div>
              } />
            </Routes>
          )}
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
